export default {
    theme: { light: 'Thème Clair', dark: 'Thème Sombre' },
    login: {
    textCredenciais: 'Entrez vos identifiants',
    acessLogin: 'Nom d’utilisateur',
    acessPassword: 'Mot de passe',
    lembrarSenha: 'Se souvenir du nom d’utilisateur et du mot de passe',
    forgotPass: 'J’ai oublié mon mot de passe',
    Enter: 'Entrer',
    escolhaApelido: 'Choisissez votre pseudonyme',
    descApelido: 'Pour continuer, définissez un pseudonyme d’affichage.'
  },
  registro: {
    titleRegister: 'S’inscrire',
    labelUsuario: "Nom d’utilisateur",
    ruleUsuarioRequired: "Le nom d’utilisateur est obligatoire",
    labelApelido: 'Pseudo',
    ruleApelidoRequired: 'Le pseudo est obligatoire',
    labelEmail: 'E-mail',
    ruleEmailRequired: "L'e-mail est obligatoire",
    ruleEmailInvalid: 'E-mail invalide',
    labelSenha: 'Mot de passe',
    ruleSenhaRequired: 'Le mot de passe est obligatoire',
    ruleSenhaMin: 'Minimum 8 caractères',
    ruleSenhaLetter: 'Utilisez au moins une lettre',
    ruleSenhaNumber: 'Utilisez au moins un chiffre',
    ruleSenhaSymbol: 'Utilisez au moins un symbole',
    strengthFraca: 'Faible',
    strengthMedia: 'Moyenne',
    strengthForte: 'Fort',
    labelRepeatPassword: 'Répéter le mot de passe',
    ruleConfirmationRequired: 'La confirmation est obligatoire',
    rulePasswordsMatch: 'Les mots de passe ne correspondent pas',
    btnRegister: "S’inscrire",
    alertSuccess: 'Compte créé ! Vérifiez votre code de confirmation.'
  },
   download: {
    title: 'Téléchargez notre client maintenant',
    btnDownload: 'Télécharger'
  },
   characters: {
    title: 'Mes personnages',
    youHave: 'Vous avez {count} personnage(s).',
    noCharacters: 'Vous n’avez pas de personnages.',
    classLabel: 'Classe :',
    levelLabel: 'Niveau :',
    goldLabel: 'Or :',
    silverLabel: 'Argent :',
    bronzeLabel: 'Bronze :',
    createdLabel: 'Création :',
    rebirthsLabel: 'Réincarnations :',
    bannedLabel: 'Banni :',
    yes: 'Oui',
    no: 'Non'
  },
    menu: {
      home: 'Accueil',
      login: 'Connexion',
      register: 'Inscrire',
      download: 'Télécharger',
      discord: 'Discord',
      info: 'Mes Infos',
      changePassword: 'Modifier les informations',
      inbox: 'Boîte (en dev)',
      market: 'Achats Zephyr',
      coinsBr: 'Zephyr Coins Brésil',
      coinsInt: 'Zephyr Coins International',
      wikia: 'Zephyr Wikia',
      ranked: 'Score Classé',
      alquimia: 'Créer Alchimie',
      atts: 'Notes de Mise à Jour',
      roulette: 'Roue de la Chance',
      daily: 'Collecte Quotidienne',
      loggedAs:'Connecté en tant que',
      casino: 'Casino Zephyr (en dev)',
      escala: 'Échelle Zephyr',
      logout: 'Déconnexion'
    },
    snackbar: { newMessages: 'Vous avez {count} nouveau(x) message(s) !' },
    footer:   { copy: '{site} - Tous droits réservés' },
    hero: {
      title:    'Grand Fantasia Zephyr',
      subtitle: 'le meilleur serveur privé de Grand Fantasia'
    },
    chat: { greeting: 'Bonjour! Nous sommes impatients de vous avoir, accédez à notre discord!' },
  
    ranks: {
      title:        'FAITS MARQUANTS',
      currentMonth: 'Mois : {month}',
      deaths:       'Top Morts',
      crystalDamage:'Top Dégâts du Cristal',
      heal:         'Top Soins',
      playerDamage: 'Top Dégâts Joueur',
      wins:         'Top Victoires',
      noData:       '— pas de données'
    },
  
    changeCreds: {
      greeting1: 'On dirait que vous n’êtes pas très en sécurité haha…',
      greeting2: 'Vous pouvez modifier vos identifiants',
      ninjaAlt:  'Ninja',
  
      newEmail: {
        label: 'Nouvel Email (!)',
        hint:  'Vous n’êtes pas obligé de changer l’email ; faites-le si vous voulez.'
      },
      currentPassword: { label: 'Mot de Passe Actuel' },
      newPassword:     { label: 'Nouveau Mot de Passe' },
      confirmPassword: { label: 'Répéter Nouveau Mot de Passe' },
  
      updateButton: 'Mettre à Jour',
  
      emailConfirmModal: {
        title:        'Confirmez votre email',
        emailField:   { label: 'Entrez votre email actuel' },
        cancelButton: 'Annuler',
        confirmButton:'Confirmer'
      },
  
      validation: {
        emailInvalid: 'Format d’email invalide',
        emailRequired:'Email requis'
      },
  
      error: {
        noChange:        'Vous ne pouvez avancer qu’en changeant email ou mot de passe.',
        fillPassword:    'Remplissez tous les champs de mot de passe.',
        passwordMismatch:'Les nouveaux mots de passe ne correspondent pas.',
        passwordLength:  'Le nouveau mot de passe doit contenir au moins 8 caractères.'
      },
  
      success: {
        updated: 'Identifiants mis à jour avec succès!'
      }
    },
    inbox: {
        title:           'Boîte de Messages ({count} en attente)',
        loginRequired:   'Vous devez être connecté pour voir vos messages.',
        from:            'de {sender}',
        gold:            '{amount} Or 🟨',
        silver:          '{amount} Argent ⚪',
        bronze:          '{amount} Bronze 🟤',
        item:            'Objet : {name}'
      },
      wiki: {
        searchPlaceholder: 'Tapez pour rechercher un objet…',
        loading:           'Chargement…',
        itemIconAlt:       'Icône de l’objet {name}',
        setItemsTitle:     'Objets du Set',
        setBonusesTitle:   'Bonus du Set',
        recipeTitle:       'Recette de Fabrication',
        recipeQty:         'Quantité : {qty}',
        obtainTitle:       'Comment l’obtenir',
        closeButton:       'Fermer'
      },
      rank: {
        selectGroupLabel: 'Sélectionner le Groupe',
        none:             '— aucun —',
        loading:          'Chargement...',
        position:         'Position',
        name:             'Nom',
        level:            'Niveau',
        class:            'Classe',
        rebirth:          'Réincarnation',
        reincarnated:     'Réincarné',
        notReincarnated:  'Non Réincarné',
    
        ranks: {
          deaths:        'Classement des Morts',
          crystalDamage: 'Classement Dégâts du Cristal',
          heal:          'Classement Soins',
          playerDamage:  'Classement Dégâts Joueur',
          wins:          'Classement Victoires'
        },
    
        stat: {
          deaths:        'Morts',
          crystalDamage: 'Dégâts Cristal',
          heal:          'Soins',
          playerDamage:  'Dégâts Joueur',
          wins:          'Victoires'
        }
      },
      alchemy: {
        title:           'Bonjour ! Bienvenue, soumettez votre suggestion d\'alchimie',
        alt:             'Image d\'alchimie',
        roundLabel:      'Tour {n} :',
        itemPlaceholder: 'ID de l\'objet {n}',
        sendButton:      'Envoyer la suggestion sur Discord',
        loginError:      'Vous devez être connecté.',
        successMessage:  'Suggestion envoyée avec succès !',
        sendError:       'Erreur lors de l\'envoi de la suggestion.',
         inserirLote: 'Insertion en masse',
        idItem:      'Entrez l’ID de l’élément',
        regras: {
        title: 'Règles !',
        forbiddenIntro: 'Non autorisé :',
        forbiddenItems: 
          'consommables de l’île pierres de la tour ou du kaos équipement tarot et butins spéciaux d’invasion, comme noyaux d’émissaire équipements (set, arme, anneau et cape) de tout type objets exclusifs d’alchimia-s top rw et objets sortis il y a moins de 2 mois objets NT du dernier round',
        conclusion: 'Toutes les alchimies seront évaluées ; si vous enfreignez les règles, elles ne seront pas validées.'
      }
      },
      escala: {
    // Títulos principais
    title: 'Échelle de récompenses',
    subtitle: "Échelle de {currentMonthName} – clôture dans : {timeRemaining}",
    spent: 'Vous avez dépensé {spentPoints} points',
    chooseYourRescue: 'Choisissez votre récompense',

    // Botão “extra eligible”
    btnExtraEligible: 'Vous avez des objets de rang à échanger',

    // Tier card (os nomes “Bronze”, “Argent” etc. ficam no data original)
    redeemed: 'Échangé',
    redeem: 'Échanger',

    // No card de pacote
    bundlePackage: 'Lot d’objets :',
    noDescription: '[Pas de description]',

    // Ranking
    topDonorsTitle: 'Nos 10 meilleurs donateurs du mois',
    columnPlayer: 'Joueur',
    columnSpent: 'Dépensé',

    // Prêmios extras
    extraRewardsTitle: 'Récompenses supplémentaires pour nos meilleurs donateurs',
    youAre: 'Vous êtes à la {rank}ᵉ place !',
    availablePrizes: 'Récompenses disponibles :',
    availablePrize: 'Récompense disponible :',
    clayX: 'Argile ×{quantity}',
    surpriseGMClick: 'Surprise GM (cliquez pour choisir)',
    instruction: 'Les objets ci-dessus sont des récompenses supplémentaires pour nos meilleurs donateurs. Ne manquez pas votre chance.',

    // Botões genéricos
    cancel: 'Annuler',
    redeemSurprise: 'Échanger Surprise',

    // Títulos de diálogos
    chooseYourSurprise: 'Surprise GM : choisissez votre objet',
    chooseYourExtraSurprise: 'Surprise GM (Récompense Supplémentaire) : choisissez votre objet',
    rescueExtraTitle: 'Échange de Récompense Supplémentaire'
  },
  service: {
    title: 'Demander Service',
    selectServiceLabel: 'Sélectionnez le service',
    options: {
      changeCharacterName: 'Changer le Nom du Personnage',
      recoverItem: 'Récupérer l’Objet',
      changeGuildName: 'Changer le Nom de la Guilde',
      recoverDeletedChar: 'Récupérer le Personnage'
    },
    selectCharLabel: 'Sélectionnez le personnage',
    newCharacterNameLabel: 'Nouveau Nom du Personnage',
    lostItemIdLabel: 'ID de l’Objet Perdu',
    newGuildNameLabel: 'Nouveau Nom de la Guilde',
    deletedCharNameLabel: 'Nom du Personnage Supprimé',
    buttonRequest: 'Demander',
    errors: {
      notAuthenticated: 'Utilisateur non authentifié.',
      selectCharAndName: 'Sélectionnez un personnage et saisissez le nouveau nom.',
      informItemId: 'Saisissez l’ID de l’objet.',
      informNewGuildName: 'Saisissez le nouveau nom de la guilde.',
      informDeletedCharName: 'Saisissez le nom du personnage supprimé.'
    },
    success: 'Demande envoyée avec succès !'
  },
  zephyr: {
    title: 'Acquérir Zephyr Points (Achat effectué en monnaie brésilienne)',
    labelAmountReal: 'Montant en Reais',
    willReceive: 'Vous recevrez :',
    coins: 'Zephyr Coins',
    buttonBuy: 'Acheter',
    errorPositive: 'Veuillez entrer un montant supérieur à zéro.',
    errorPayment: 'Impossible de lancer le paiement. Veuillez réessayer.',
    docTitle: 'Grand Fantasia Zephyr'
  },
   acquire: {
    title: 'Acheter des points Zephyr (achat effectué avec une devise internationale)',
    labelValueReal: 'Montant en Reais',
    receive: 'Vous recevrez :',
    coins: 'Zephyr Coins',
    approxUSD: 'Environ {usd} USD',
    sendOrderButton: 'Envoyer la commande',
    alertValueGreaterZero: 'Veuillez entrer un montant supérieur à zéro.',
    alertLogin: 'Veuillez vous connecter pour continuer.',
    alertSuccess: 'Commande envoyée ! Vous recevrez {coins} Zephyr Coins (≈ {usd} USD).',
    alertError: 'Impossible d’envoyer la commande. Veuillez réessayer.'
  },
    daily:{
    title:'Récompense quotidienne',
    subtitle:"Réclamez votre récompense quotidienne aujourd'hui",
    rescue:'Sauvetage'
  },
  roulette: {
    headerTitle: 'Roulette de la Chance Zephyr',
    headerSubPoints: 'Prix de la roulette : 500 Zephyr points',
    headerSubBonus: 'Prix de la roulette : 1000 Zephyr bonus',
    user: 'Utilisateur',
    pointsLabel: 'Points',
    bonusLabel: 'Bonus',
    title: 'Roulette de la Chance',
    spinButtonAlt: 'Tourner',
    insufficientTitle: 'Solde insuffisant',
    insufficientMessage: 'Vous avez besoin de {cost} Zephyr points pour tourner.',
    close: 'Fermer',
    congratsTitle: 'Félicitations !',
    congratsMessage:
      'Félicitations, vous avez gagné {quantity}x {name}. Consultez la boutique du jeu et réclamez votre récompense.'
  }
  }
  